import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import Typewriter from './Typewriter';

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-carbon border-t border-white/5 relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl mx-auto bg-obsidian border border-white/10 p-6 md:p-12 relative shadow-2xl">
          <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-neon-cyan"></div>
          <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-neon-cyan"></div>
          
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-4xl font-orbitron font-bold text-white mb-4">
              <Typewriter text="INITIATE NEW BUILD" />
            </h2>
            <p className="text-gray-400 text-sm md:text-base">Ready to engineer something intelligent? Let's talk.</p>
          </div>
          
          <form className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <input type="text" className="w-full bg-steel/30 border border-white/10 p-3 text-white focus:border-neon-cyan focus:outline-none text-sm" placeholder="Identifier / Name" />
              <input type="email" className="w-full bg-steel/30 border border-white/10 p-3 text-white focus:border-neon-cyan focus:outline-none text-sm" placeholder="Comms / Email" />
            </div>
            <textarea rows="4" className="w-full bg-steel/30 border border-white/10 p-3 text-white focus:border-neon-cyan focus:outline-none text-sm" placeholder="Mission Parameters / Message"></textarea>
            <button type="button" className="w-full py-4 bg-neon-cyan/10 border border-neon-cyan text-neon-cyan font-bold font-orbitron tracking-widest hover:bg-neon-cyan hover:text-black transition-all uppercase text-sm">
              Transmit Data
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;